import React from "react";
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
    return (
        <>
            {/* Hero */}
            <section className="hero">
                <div className="hero-overlay">
                    <div className="hero-content">
                        <span className="hero-eyebrow">Gemeinnütziger Verein e.V.</span>
                        <h1 className="hero-title">Afrika-Link</h1>
                        <p className="hero-subtitle">
                            Wir bauen eine Brücke zwischen Europa und Afrika –<br className="hero-br" />
                            für Verständnis, Austausch und nachhaltige Entwicklung.
                        </p>
                        <div className="hero-actions">
                            <Link className="btn-primary" to="/about">Wer wir sind</Link>
                            <Link className="btn-outline" to="/projekte">Unsere Projekte</Link>
                        </div>
                    </div>
                </div>
            </section>

            {/* Vision */}
            <section className="section section-light">
                <div className="container">
                    <div className="section-grid">
                        <div className="section-label">
                            <p className="label-sub">Über uns</p>
                            <h2>Unsere Vision</h2>
                        </div>
                        <div className="section-body">
                            <p>
                                Afrika-Link steht für eine Verbindung zwischen Europa und Afrika – ein „Link", der nicht nur
                                symbolisch für die Verbindung der beiden Kontinente steht, sondern auch den Namen unseres
                                Gründers Peter Link aufgreift. Diese Brücke soll den Austausch und das gegenseitige
                                Verständnis fördern.
                            </p>
                            <p>
                                Wir möchten dazu beitragen, dass Menschen aus Europa und Afrika zueinanderfinden und sich
                                gegenseitig bereichern – nicht nur wirtschaftlich, sondern auch kulturell und sozial. Unser
                                Fokus liegt auf Tansania, wo wir konkrete Projekte in den Bereichen Bildung, Landwirtschaft
                                und berufliche Qualifizierung umsetzen.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Three pillars */}
            <section className="section section-green">
                <div className="container">
                    <h2 className="section-title-white">Was uns antreibt</h2>
                    <div className="pillars">
                        <div className="pillar-card">
                            <div className="pillar-icon">&#9679;</div>
                            <h3>Einander Verstehen</h3>
                            <p>
                                Vertrauen entstehen lassen, Wohlwollen und Freundschaft entwickeln –
                                ein wichtiges Fundament für Frieden in der Welt.
                            </p>
                        </div>
                        <div className="pillar-card">
                            <div className="pillar-icon">&#9679;</div>
                            <h3>Voneinander Lernen</h3>
                            <p>
                                Den Horizont erweitern, Toleranz schaffen und gemeinsam wachsen –
                                von der Vielfalt beider Kulturen profitieren.
                            </p>
                        </div>
                        <div className="pillar-card">
                            <div className="pillar-icon">&#9679;</div>
                            <h3>Gemeinsam Entwickeln</h3>
                            <p>
                                Hoffnung entstehen lassen, Chancen nutzen und Menschen helfen,
                                ein selbstbestimmtes Leben zu führen.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Image break */}
            <div className="image-break"></div>

            {/* Mission */}
            <section className="section section-sand">
                <div className="container">
                    <div className="section-grid">
                        <div className="section-label">
                            <p className="label-sub">Unsere Arbeit</p>
                            <h2>Mission</h2>
                        </div>
                        <div className="section-body">
                            <p>
                                Unsere Mission ist es, junge Menschen in Afrika dabei zu unterstützen, ihr volles Potenzial
                                zu entfalten und nachhaltige Entwicklung in ihren Heimatländern zu fördern. Dabei setzen
                                wir auf Hilfe zur Selbsthilfe, um langfristige Erfolge zu erzielen.
                            </p>
                            <p>
                                Im Zentrum unserer Arbeit stehen die Errichtung von Kompetenz- und Innovationszentren in
                                Tansania. Wir bieten motivierten Menschen die Chance, die deutsche Sprache zu erlernen und
                                eine Ausbildung in Deutschland zu absolvieren – um anschließend mit ihren neu erworbenen
                                Fähigkeiten den Aufbau von Wohlstand und Freiheit in ihrer Heimat voranzutreiben.
                            </p>
                            <p>
                                Zudem eröffnen wir Menschen aus Europa die Möglichkeit, die afrikanische Kultur durch
                                Freiwilligendienste, Praktika oder längere Aufenthalte in Tansania zu erleben.
                            </p>
                            <div className="mission-cta">
                                <Link className="btn-primary" to="/projekte">Projekte entdecken</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Quote */}
            <section className="quote-band">
                <blockquote>
                    <p>„Bildung ist die mächtigste Waffe, mit der du die Welt verändern kannst."</p>
                    <cite>— Nelson Mandela</cite>
                </blockquote>
            </section>
        </>
    );
};

export default Home;
